import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Pressable, ScrollView, StyleSheet, TextInput as RNTextInput, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { ArrowIcon, Button as Button95, Checkbox, Hourglass, NumberInput, Panel, Radio, TextInput } from 'react95-native-rabbl';
import { AppText } from '@/components/AppText';
import { CustomDivider } from "@/components/CustomDivider";
import Head from 'expo-router/head';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import Footer from '@/components/Footer';
import * as AppUtilities from "@/utilities/AppUtilities";
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConstants from "@/utilities/AppConstants";
import * as AppConsts from "@/utilities/AppConsts";
import { useForm, Controller, Resolver } from "react-hook-form";
import { AppContext } from '@/components/AppContext';
import { CommunityMembership } from "@/types/community_membership";
import { Link, RelativePathString, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setData } from '@/state/user';
import { Image } from 'expo-image';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  formElement: {
    width: AppConsts.BASIC_MINIMUM_WIDTH,
  },
  buttonWrapper: {
    flexDirection: 'row',
  },
  panel: {
    padding: 20,
    gap: 20,
    maxWidth: 500,
  },
  numericWrapper: {
    flexDirection: 'row',
    gap: 5,
  },
  numeric: {
    width: 80,
  },
  alignLeft: {
    alignSelf: 'flex-start',
  },
  checkboxWithIcon: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  center: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  cookieimage: {
    width: 35,
    height: 35,
  },
  cookieopacity: {
    opacity: 0.5,
  },
});

export default function UserInfo() {
  const domain = useSelector((state: RootState) => state.user.domain);
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const router = useRouter();
  const dispatch = useDispatch();

  const [accepted_terms, setaccepted_terms] = useState(true);
  const [accepted_cookies, setaccepted_cookies] = useState(false);
  const [accepted_essential_cookies, setaccepted_essential_cookies] = useState(false);
  // ---------------------
  // ^^ Don't forget to add new items to the dependencies of onSubmit
  // ---------------------

  const onSubmit = useCallback(async() => {
    try {
      showSpinner();

      const response = await AppUtilities.fetchAuthorized(
        "UserInfo.onSubmit",
        "/rabbl/api/set_user_info",
        "POST",
        {
          domain: domain,
          accepted_terms: accepted_terms,
          accepted_cookies: accepted_cookies,
          accepted_essential_cookies: accepted_essential_cookies,
        }
      );
      const membership: CommunityMembership = ((response as any).body as any).community_membership;
      dispatch(setData(response));
      const nextPage = AppUtils.getProfileCreateNextPageLink(membership);
      AppUtilities.info("UserInfo.onSubmit nextPage: " + nextPage);
      router.navigate(nextPage as RelativePathString);

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(), true);
      AppUtilities.handleException(e, "UserInfo.onSubmit");
    } finally {
      hideSpinner();
    }
  },
  [
    domain,
    accepted_terms,
    accepted_cookies,
    accepted_essential_cookies,
  ]);

  const onPressCookie = useCallback(() => {
    setaccepted_essential_cookies(accepted_essential_cookies ? false : true);
  }, [accepted_essential_cookies]);

  const cookieImageStyles = accepted_essential_cookies ? [styles.cookieimage] : [styles.cookieimage, styles.cookieopacity];

  return (
    <BasicScrollView center={true}>
      <Meta title={"Cookies"} />
            
      <Panel variant='raised' elevation={4}>
        <View style={styles.panel}>

          {/*
          <View style={styles.center}>
            <CustomText>Terms</CustomText>
          </View>

          <AppText>Please review our <Link href='/terms' style={CustomTextStyles.link}>terms of use</Link>.</AppText>

          <Checkbox
            status={accepted_terms ? 'checked' : 'unchecked'}
            onPress={() => setaccepted_terms(accepted_terms ? false : true)}
            label="I accept the terms"
          />

          <CustomDivider fullWidth={true} />

          */}

          {/*<View style={styles.center}>
            <CustomText>Cookies</CustomText>
          </View>*/}

          <AppText>Rabbl only uses cookies to remember that you're logged in. Visit our <Link href='/privacy' style={CustomTextStyles.link}>privacy policy</Link> for more information.</AppText>

          {/*<AppText>Rabbl uses cookies to remember that you're logged in. We need your approval because Europe or something. Visit our <Link href='/privacy' style={CustomTextStyles.link}>privacy policy</Link> for more information.</AppText>*/}

          {/*
          <Radio
            status={accepted_cookies ? 'checked' : 'unchecked'}
            onPress={() => {
              setaccepted_cookies(true);
              setaccepted_essential_cookies(false);
            }}
            label="Accept all cookies"
          />

          <Radio
            status={accepted_essential_cookies ? 'checked' : 'unchecked'}
            onPress={() => {
              setaccepted_essential_cookies(true);
              setaccepted_cookies(false);
            }}
            label="Accept only essential cookies"
          />
          */}

          <View style={{ flexDirection: "row", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <View>
              <Checkbox
                status={accepted_essential_cookies ? 'checked' : 'unchecked'}
                onPress={onPressCookie}
                label="I agree"
              />
            </View>
            <Pressable onPress={onPressCookie}><Image source={require('@/assets/images/minis/cookie7.gif')} style={cookieImageStyles} /></Pressable>
            <Pressable onPress={onPressCookie}><Image source={require('@/assets/images/minis/cookie1.gif')} style={cookieImageStyles} /></Pressable>
            <Pressable onPress={onPressCookie}><Image source={require('@/assets/images/minis/cookie2.gif')} style={cookieImageStyles} /></Pressable>
            {/*<Pressable onPress={onPressCookie}><Image source={require('@/assets/images/minis/cookie3.gif')} style={cookieImageStyles} /></Pressable>*/}
            {/*<Pressable onPress={onPressCookie}><Image source={require('@/assets/images/minis/cookie4.gif')} style={cookieImageStyles} /></Pressable>*/}
            {/*<Pressable onPress={onPressCookie}><Image source={require('@/assets/images/minis/cookie5.gif')} style={cookieImageStyles} /></Pressable>*/}
            <Pressable onPress={onPressCookie}><Image source={require('@/assets/images/minis/cookie6.gif')} style={cookieImageStyles} /></Pressable>
          </View>

          <View style={styles.buttonWrapper}>
            <Button95
              onPress={onSubmit}
              disabled={!accepted_terms || (!accepted_cookies && !accepted_essential_cookies)}
            >Next</Button95>
          </View>
        </View>
      </Panel>
      
      <Footer />
    </BasicScrollView>
  );
}
